// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_deleteMessageBroadcast(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["MessageBroadcastWasDeleted"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"deleteMessageBroadcast":{"u":"response_deleteMessageBroadcast"}}};

let wrapResponseConverterMap = {
  response_deleteMessageBroadcast: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"deleteMessageBroadcast":{"u":"response_deleteMessageBroadcast"}}};

let responseConverterMap = {
  response_deleteMessageBroadcast: unwrap_response_deleteMessageBroadcast
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "messageBroadcastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "messageBroadcastId",
    "variableName": "messageBroadcastId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedMessageBroadcastNodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteMessageBroadcast",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "MessageBroadcastWasDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteMessageBroadcast",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "deletedMessageBroadcastNodeId",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "type": "MessageBroadcastWasDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e8ffeb775ddfeb08076902bc1507d1bb",
    "id": null,
    "metadata": {},
    "name": "MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation",
    "operationKind": "mutation",
    "text": "mutation MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation(\n  $messageBroadcastId: ID!\n) {\n  deleteMessageBroadcast(messageBroadcastId: $messageBroadcastId) {\n    __typename\n    ... on MessageBroadcastWasDeleted {\n      deletedMessageBroadcastNodeId\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_deleteMessageBroadcast = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_deleteMessageBroadcast = unwrap_response_deleteMessageBroadcast;
exports.wrap_response_deleteMessageBroadcast = wrap_response_deleteMessageBroadcast;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
